import { Section } from '@/ui/overlays/EntityDrawer';
import { useTranslation } from 'react-i18next';

/** Live chat at the foot of the support drawer. */
export default function CrispIframe({ WEBSITE_ID }: { WEBSITE_ID?: string }) {
  const { t } = useTranslation();
  if (!WEBSITE_ID) return null;
  return (
    <Section title={t('Chat with us')}>
      <iframe
        title={t('Support chat')}
        src={`https://go.crisp.chat/chat/embed/?website_id=${WEBSITE_ID}`}
        className="block h-[415px] w-full overflow-hidden rounded-surface border border-border-subtle"
      />
    </Section>
  );
}
